import { useEffect } from "react";
import { useParams, useNavigate, Link} from "react-router-dom";

import { Header } from "../../common/Header";
import { getArticle } from "../../utils/data/data";
import { Footer } from "../../common/Footer";
import { Icons } from '../../utils/Icons'
import arrowBackIcon from '../../assets/img/arrowBack.svg'

export default function Article() {
  let navigate = useNavigate();
  let params = useParams();
  let article = getArticle(params.articleId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="appContainer isArticle">
      <div className="mainHeader small">
        <Header />
      </div>
      <main className="mainWidth">
        <button 
          onClick={() => navigate(-1)} 
          className="smallButton"
        >
          <Icons path={arrowBackIcon} />
          Volver
        </button>
        <article className="mainArticle">
          <div className="breadCrumb">
            <Link to="/">Inicio</Link>
            <span>&gt;</span>
            <p>{article.category.name}</p>
            <span>&gt;</span>
            <p>{article.title}</p>
          </div>
          <header>
            <h1>{article.title}</h1>
          </header>
          <div className="articleContent">
            {article.content}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}